var React = require('react');

function ReportOutage (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#27788C;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")),React.createElement("g",{"transform":"translate(1.332 1)","key":1},[React.createElement("path",{"className":"a","d":"M-1788.2-1442.4l1.384-1.971-8.218-3.941,3.772-18.407-12.1,17.23","transform":"translate(1818.19 1466.718)","key":0}),React.createElement("path",{"className":"a","d":"M-1805.489-1443.737l-2.471,3.519,8.218,3.941-3.773,18.408,13.132-18.7","transform":"translate(1818.952 1462.902)","key":1}),React.createElement("line",{"className":"a","x1":"42.714","y1":"20.274","transform":"translate(0 12.774)","key":2})])]);
}

ReportOutage.defaultProps = {"width":"45.378","height":"47.032","viewBox":"0 0 45.378 47.032"};

module.exports = ReportOutage;

ReportOutage.default = ReportOutage;
